import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { base_url } from "../../context/Authcontext";

const ProtectedRoute = () => {
  const [isValid, setIsValid] = useState(null); // null = loading, true = valid, false = invalid
  
  const role = localStorage.getItem('role');
  const phoneNumber = localStorage.getItem('phoneNumber');

  const location = useLocation(); // Detect route change

  useEffect(() => {
    const token = localStorage.getItem('admin');
    // console.log('token',token);
    const validateToken = async () => {
      if (!token) {
        setIsValid(false);
        return;
      }

      try {
        const res = await axios.post(`${base_url}/api/webapi/authcheck`, { phoneNumber, token });

        if (res.data.status) {
          setIsValid(true);
        } else {
          localStorage.removeItem('admin');
          localStorage.removeItem('role');
          localStorage.removeItem('phoneNumber');
          toast.error('Session expired. Please login again.');
          setIsValid(false);
        }
      } catch (error) {
        console.log(error);
        localStorage.removeItem('admin');
        localStorage.removeItem('role');
        localStorage.removeItem('phoneNumber');
        toast.error('Session expired. Please login again.');
        setIsValid(false);
      }
    };

    validateToken();
  }, [location.pathname]); // Runs on every route change

  if (isValid === null) {
    return <div>Loading...</div>;
  }

  return isValid ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;